import React, { useState } from 'react'
import styled from 'styled-components'

import { theme } from '@/theme'

import { Button, TextInput } from '../../uikit'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Label = styled.div`
  font-weight: ${theme.fontWeight.medium};
`

const Input = styled(TextInput)`
  margin-top: 8px;
  margin-bottom: 16px;
`

export const ShareLink = ({ link }: { link: string }) => {
  const [isCopied, setIsCopied] = useState(false)
  const onCopy = () => {
    navigator.clipboard.writeText(link)
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }

  return (
    <Wrapper>
      <Label>Share Link</Label>
      <Input disabled value={link} placeholder="Link" />
      <Button mode="secondary" isFullWidth type="button" onClick={onCopy}>
        {isCopied ? 'Copied' : 'Copy Link'}
      </Button>
    </Wrapper>
  )
}
